<template>
  <v-card flat>
    <v-data-table
      :items="rawmaterials"
      :search="search"
      :headers="headers"
      v-model="selected"
      @item-selected="expandlabel"
      show-select
      single-select
    >
      <template v-slot:top="{ item }">
        <v-toolbar flat>
          <v-toolbar-title>
            <v-icon left>grain</v-icon>
            Raw Material Inventory
          </v-toolbar-title>
          <v-spacer />
          <RawMaterialForm :materialid="id" :is-edit="false" />
        </v-toolbar>
      </template>
      <template v-slot:item.archived="{ item }">
        <ArchiveForm :instance="item" />
      </template>
      <template v-slot:item.quantity="{ item }">
        {{ item.quantity }}{{ item.units }}
      </template>
      <template v-slot:item.location="{ item }">
        <LocationTag :location="item.location" />
      </template>
      <template v-slot:item.action="{ item }">
        <RawMaterialForm
          :materialid="id"
          :is-edit="true"
          :instance="item"
        />
      </template>
    </v-data-table>
    <div v-for="item in selected" :key="item.id">
      <v-card-text>
        <p>{{ item.notes }}</p>
        <v-row justify="center">
          <v-col sm="12" md="6">
            <router-view :rawmaterial="item" />
          </v-col>
        </v-row>
      </v-card-text>
    </div>
  </v-card>
</template>

<script>
import RawMaterialForm from "./RawMaterialForm";
import ArchiveForm from "../State/ArchiveForm";
import LocationTag from "../Locations/LocationTag";
export default {
  name: "RawMaterialsTable",
  components: {
    LocationTag,
    ArchiveForm,
    RawMaterialForm
  },
  props: {
    rawmaterials: {
      type: Array,
      required: true,
      default: () => []
    }
  },
  data() {
    return {
      selected: [],
      id: this.$route.params.id,
      search: "",
      rowsper: [
        25,
        50,
        { text: "$vuetify.dataIterator.rowsPerPageAll", value: -1 }
      ],
      headers: [
        { text: "Status", sortable: false, value: "archived" },
        { text: "BarCode", align: "left", sortable: true, value: "barcode" },
        { text: "Name", sortable: true, value: "name" },
        { text: "Quantity", sortable: true, value: "quantity" },
        { text: "Lot Number", sortable: true, value: "lotnumber" },
        { text: "Location", sortable: true, value: "location" },
        { text: "Actions", sortable: false, value: "action" }
      ]
    };
  },
  methods: {
    expandlabel(obj) {
      if (obj.value) {
        this.$router.push({
          name: "RawMaterialPrint",
          params: { rawid: obj.item.id }
        });
      } else {
        this.$router.push({
          name: "RawMaterials"
        });
      }
    }
  }
};
</script>
